import { Link } from "react-router-dom";
import { Compass, Home } from "lucide-react";
import { ERRORS } from "@/constants/testIds";

export default function NotFoundPage() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-[#F8FAFC] px-4" data-testid={ERRORS.notFound}>
      <div className="max-w-md rounded-2xl border border-slate-200 bg-white p-10 text-center shadow-sm">
        <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-[#101876]/10 text-[#101876]">
          <Compass className="h-6 w-6" />
        </div>
        <div className="mt-6 text-xs font-bold uppercase tracking-[0.3em] text-[#329112]">404</div>
        <h1 className="mt-2 text-2xl font-black text-slate-900" style={{ fontFamily: "Cabinet Grotesk, sans-serif" }}>Page not found</h1>
        <p className="mt-2 text-sm text-slate-600">
          The page you're looking for doesn't exist or has moved. Let's get you back on track.
        </p>
        <Link
          to="/"
          className="mt-6 inline-flex items-center gap-2 rounded-md bg-[#101876] px-5 py-2.5 text-sm font-semibold text-white transition hover:bg-[#0c135c]"
          data-testid={ERRORS.homeLink}
        >
          <Home className="h-4 w-4" /> Back to home
        </Link>
      </div>
    </div>
  );
}
